import type { ReactNode } from 'react';

import type { LANGUAGE } from '@/types/commonConst';

import { getFeatureMessage } from '..';
import { workflowMessages } from './messages';

export type WorkflowMessageKey = keyof typeof workflowMessages;

export const getWorkflowMessage = (
  lang: LANGUAGE,
  key: WorkflowMessageKey,
): ReactNode => {
  return getFeatureMessage(workflowMessages[key], lang);
};
